__turbopack_context__.v({
  "container": "lHuFNG_container",
  "heading": "lHuFNG_heading",
});
